import { Component } from '@angular/core';
import { hotCallDetails } from '../../common/models/hotCall.model';
import { HotCallStatusService } from '../../common/services/hot-call-status.service';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { FilterService } from 'src/app/common/services/filter.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { GET_MYHOTCALL } from '../../common/graphql/queries';
import { CommonserviceService } from 'src/app/common/services/commonservice.service';
import { DatePipe } from '@angular/common';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { ErrorHandlerService } from 'src/app/common/services/error-handler.service';
import { DataService } from 'src/app/common/services/data.service';
import { userApplConfigSignal } from 'src/app/common/signals/user-profile-signal';

@Component({
  selector: 'app-my-hot-calls',
  templateUrl: './my-hot-calls.component.html',
  styleUrls: ['./my-hot-calls.component.css'],
  providers: [DatePipe]
})
export class MyHotCallsComponent {
  myHotcallForm: FormGroup;
  hotCallDetails : hotCallDetails;
  statusClass : string = "";
  isLoading: boolean = false;
  sortState: 'normal' | 'asc' | 'desc' = 'normal';
  constructor(
    private readonly fb: FormBuilder,
    private readonly hotCallStatusService: HotCallStatusService,
    private readonly filterService: FilterService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly commonsService: CommonserviceService,
    private readonly datePipe: DatePipe,
    private readonly dataService: DataService,
    private readonly spinner: SpinnerService,
    private readonly errorService: ErrorHandlerService
  ) {
    translate.setDefaultLang('en');
  }
  myHotCalls: hotCallDetails[] = [];
  public filteredHotCalls: hotCallDetails[] = [];
  public searchQuery: string = '';
  private readonly searchSubject = new Subject<string>();
  public selectedStatus: string = '';
  public statusOptions : string[] = [];

  ngOnInit(): void {
    this.errorService.clearErrorMessage();
    this.myHotCalls = [];
    this.filteredHotCalls = [];
    this.spinner.show();
    const plantName = userApplConfigSignal().plantName;
    const shopName = userApplConfigSignal().shopName;
    const lineName = userApplConfigSignal().lineName;
    const userId = this.dataService.getWorkDayId().toString();
    this.commonsService.getHcmData(GET_MYHOTCALL, { userId, plantName, shopName, lineName }).subscribe({
      next: (response) => {
      if (response?.data?.getMyHotCalls?.length) {
        this.myHotCalls = response.data.getMyHotCalls;
        this.statusOptions = [...new Set(this.myHotCalls.map(t => t.ticketStatus))];
        this.filteredHotCalls = this.myHotCalls;
        this.statusClass = this.hotCallStatusService.getHotCallStatus(this.myHotCalls[0]?.ticketStatus);
        this.hotCallDetails = this.myHotCalls[0];
      } else {
        this.myHotCalls = [];
        this.filteredHotCalls = [];
        this.spinner.hide();
      }
      if(response?.errors){
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      }
      },
      error: (error) => {
        this.spinner.hide();
        this.errorService.setErrorMessage([]);
      },
      complete: () => {
        this.spinner.hide();
      }
    });

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.filterHotCalls(searchTerm, this.selectedStatus);
    });
    this.myHotcallForm = this.fb.group({
      searchQuery: ['',],
      selectedStatus: ['',],
        });
        this.myHotcallForm.valueChanges.subscribe(values => {
          this.filteredHotCalls = this.filterService.filterHotCalls(values.searchQuery, values.selectedStatus, this.myHotCalls)
        });
  }


  public filterHotCalls(searchTerm: string, status: string): void {
    this.filteredHotCalls = this.filterService.filterHotCalls(searchTerm, status, this.myHotCalls);
  }

  public selectHotCall(hotCallLineData: hotCallDetails) : void {
    this.statusClass = this.hotCallStatusService.getHotCallStatus(hotCallLineData.ticketStatus)
    this.hotCallDetails = hotCallLineData;
  }

  public getHotCallStatus(status : string) : string {
    return this.hotCallStatusService.getHotCallStatus(status);
  }

  public backToHome(): void {
    this.router.navigateByUrl('home')
  }

  public toggleSortOrder(): void {
    const result = this.filterService.toggleSortOrder(this.filteredHotCalls, this.sortState);
    this.filteredHotCalls = result.sortedData;
    this.sortState = result.sortState;
  }
  public getStatus(ticketStatus : string) : string{
    return this.hotCallStatusService.getHotCallStatusByCode(ticketStatus);
  }
}
